import { GrantDiscordAccessMutation1e5ff0b653k4l as GrantDiscordAccessMutation } from './schema/GrantDiscordAccessMutation.mjs';
import { toVoidResult8ga34bq1f52r as toVoidResult } from './SdkGrantSlackAccess.mjs';
import { Unauthorized_instanceghuvz1uf98qj as Unauthorized_instance } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/CommandResult.mjs';
import { Dispatcher27uwezb7p8fpg as Dispatcher } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/GrantDiscordAccessCommand.mjs';
import { GqlTrait2wtoeyl3yfalb as GqlTrait } from './gql/GqlTrait.mjs';
import { initMetadataForInterface1egvbzx539z91 as initMetadataForInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { GrantDiscordAccessInputqu7hxtlblgwv as GrantDiscordAccessInput } from './schema/type/GrantDiscordAccessInput.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *perform(command, $completion) {
  var tmp0_safe_receiver = (yield* this.i6y(new (GrantDiscordAccessMutation())(grantDiscordAccessInput(command)), $completion)).a45_1;
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.q6j_1;
  var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : toVoidResult(tmp1_safe_receiver);
  return tmp2_elvis_lhs == null ? Unauthorized_instance : tmp2_elvis_lhs;
}
var SdkGrantDiscordAccessClass;
function SdkGrantDiscordAccess() {
  if (SdkGrantDiscordAccessClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'SdkGrantDiscordAccess', VOID, VOID, [Dispatcher(), GqlTrait()], [1]);
    SdkGrantDiscordAccessClass = $;
  }
  return SdkGrantDiscordAccessClass;
}
function grantDiscordAccessInput(_this__u8e3s4) {
  var tmp0_code = _this__u8e3s4.l2l_1;
  var tmp1_state = _this__u8e3s4.o2l_1;
  var tmp2_verifier = _this__u8e3s4.p2l_1;
  var tmp3_partyId = _this__u8e3s4.n2l_1;
  var tmp4_guildId = _this__u8e3s4.m2l_1;
  return new (GrantDiscordAccessInput())(tmp1_state, tmp2_verifier, tmp0_code, tmp3_partyId, tmp4_guildId);
}
//region block: exports
export {
  SdkGrantDiscordAccess as SdkGrantDiscordAccessjjorbkvtrfx9,
  perform as perform24j244entfy0d,
};
//endregion

//# sourceMappingURL=SdkGrantDiscordAccess.mjs.map
